<template>
  <div class="container page base-setting-page">
    <van-nav-bar :title="$t('setting.base_setting')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template>
    </van-nav-bar>

    <div class="main-content">
<!--      <div class="item van-hairline&#45;&#45;bottom" @click="openHerderImg()">-->
<!--        <div class="left">-->
<!--          <van-icon name="user-circle-o" class="item-icon" />-->
<!--          <span>{{ $t("setting.avatar") }}</span>-->
<!--        </div>-->
<!--        <div class="right">-->
<!--          <img class="avatar-img" :src="userInfo.header_img || '/img/avatar.png'" />-->
<!--          <van-icon name="arrow" />-->
<!--        </div>-->
<!--      </div>-->

      <div class="item van-hairline--bottom" @click="toSetName()">
        <div class="left">
          <van-icon name="card" class="item-icon" />
          <span>{{ $t("setting.real_name") }}</span>
        </div>
        <div class="right">
          <span class="desc">{{ userInfo.name ? userInfo.name : $t("setting.no_setting") }}</span>
          <van-icon name="arrow" />
        </div>
      </div>

      <div class="item van-hairline--bottom" @click="toSetSex()">
        <div class="left">
          <van-icon name="flower-o" class="item-icon" />
          <span>{{ $t("setting.sex") }}</span>
        </div>
        <div class="right">
          <span class="desc">
            {{ userInfo.sex !== "0" ? userInfo.sex === "1" ? $t("setting.man") : $t("setting.female") : $t("setting.unkown") }}
          </span>
          <van-icon name="arrow" />
        </div>
      </div>

      <div class="item van-hairline--bottom" @click="toSetBank()">
        <div class="left">
          <van-icon name="card" class="item-icon" />
          <span>{{ $t("setting.bind_bank_info") }}</span>
        </div>
        <div class="right">
          <span class="desc bank-status">{{ isBank ? $t("setting.bindinged") : $t("setting.no") }}</span>
          <van-icon name="arrow" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActive:false,
      show:false,
      isBank:false,
      userInfo:{}
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    toSetName(){
      this.$router.push({path:'/Setname'});
    },
    toSetBank(){
      this.$router.push({path:'/Setbank'});
    },
    toSetSex(){
      this.$router.push({path:'/Setsex'});
    },
    openHerderImg(){
      this.show = true;
    },
    select_header_img(url){
        this.isActive = url;
    },
    check(){
      this.$http({
        method: 'post',
        data:{header_img:this.isActive},
        url: 'user_header_img'
      }).then(res=>{
        if(res.code === 200){
          this.getUserInfo();
          this.$toast(res.msg);
          this.show = false;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getUserBankInfo(){
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res=>{
        if(res.code === 200){
          if(res.data.is_bank){
            this.isBank = true;
          }else {
            this.isBank = false;
          }
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
      this.getUserBankInfo();
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";

.base-setting-page {
  position: relative;
  min-height: 100vh;
  overflow: hidden;
  background: #211923 url("https://xhtd888.oss-cn-hongkong.aliyuncs.com/uu8/sts/hk_login.png") no-repeat top center;
  background-size: cover;
}

.base-setting-page::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: 0;
  background:
      linear-gradient(180deg, rgba(18,14,20,.25) 0%, rgba(44,25,47,.55) 48%, rgba(88,53,83,.82) 100%),
      rgba(30,20,33,.25);
}

.base-setting-page > * {
  position: relative;
  z-index: 1;
}

.nav-bar {
  background: transparent !important;
  box-shadow: none !important;
}

::v-deep .van-nav-bar__title {
  color: #fff;
  font-size: 32px;
  font-weight: 800;
}

::v-deep .van-nav-bar__left {
  left: 18px;
}

::v-deep .van-icon-arrow-left {
  width: 58px;
  height: 58px;
  line-height: 58px;
  text-align: center;
  border-radius: 50%;
  background: rgba(255,255,255,.18);
  font-size: 40px !important;
}

.main-content {
  margin: 70px 26px 0;
  padding: 26px 28px;
  border-radius: 24px;
  background: rgba(112, 99, 110, 0.72);
  border: 1px solid rgba(255,255,255,.16);
  box-shadow:
      0 18px 34px rgba(0,0,0,.22),
      inset 0 1px 0 rgba(255,255,255,.22);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
}

.main-content .item {
  padding: 30px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 30px;
}

.main-content .item:last-child::after {
  display: none;
}

.main-content .van-hairline--bottom::after {
  border-bottom-color: rgba(255,255,255,.12);
}

.left {
  display: flex;
  align-items: center;
  color: #fff;
  font-size: 30px;
  font-weight: 700;
}

.item-icon {
  width: 58px;
  height: 58px;
  margin-right: 24px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 34px !important;
  background: rgba(255,255,255,.16);
}

.right {
  display: flex;
  align-items: center;
  color: rgba(255,255,255,.65);
}

.right .desc {
  font-size: 28px;
  font-weight: 700;
  color: rgba(255,255,255,.72);
  margin-right: 14px;
}

.right .bank-status {
  color: #75f08b;
}

.avatar-img {
  width: 58px !important;
  height: 58px !important;
  border-radius: 50%;
  margin-right: 14px;
  border: 2px solid rgba(255,255,255,.65);
}

.avatarbox {
  padding: 15px;
  color: #000;
  height: 81%;
  background-color: #fff;
}

.avatarbox .title {
  padding: 8px 10px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 28px;
}

.avatarbox .content {
  padding-bottom: 10px;
  height: 100%;
  overflow-y: auto;
  padding-top: 20px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

.avatarbox .content .van-image {
  width: 105px;
  height: 105px;
  margin: 2.5%;
  border-radius: 50%;
}

.avatarbox .content .choose {
  width: 95px;
  height: 95px;
  border: 6px solid #e6c3a1;
}
</style>
